import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'

export default function useRedux() {
  const dispatch = useDispatch<AppDispatch>()
  return { dispatch }
}
